import { getDate } from 'date-fns/getDate'

import { createTestId } from 'aem-libs-tests/src/utility/createTestId'
import { Maybe } from 'aem-libs-ts/src/types/utility'
import { formatDateISO } from 'aem-libs-ts/src/utils/formatting/dates/formatDateISO'

import { DisableDatesFn } from '../types'
import { useDatesTransform } from '../useDatesTransform'
import { CalendarButton } from './CalendarButton'


interface DateScreenProps {
  disableDates: Maybe<DisableDatesFn>
  testId: string
  date: Date
  focusedDate: Date
  onChangeDate: (date: number) => void
  customRef: (node: HTMLTableSectionElement) => void
}

export const DateScreen = ({ date, disableDates, onChangeDate, testId, customRef, focusedDate }: DateScreenProps) => {
  const dates = useDatesTransform(date, disableDates)

  return (
    <tbody data-testid={createTestId(testId, 'list')} ref={customRef}>
      {dates.map((dw, index) => (
        <tr key={index} role='row' data-row={index}>
          {dw.map((d, dayIndex) => (
            <td
              key={d.dataDate}
              tabIndex={getDate(focusedDate) === d.date && !(d.disabled || !d.selectable) ? 0 : -1}
              aria-selected={formatDateISO(date) === d.dataDate}
              data-cell={dayIndex}
              data-date={d.dataDate}
              role='gridcell'
            >
              <CalendarButton
                data-day={d.date}
                tabIndex={-1}
                data-testid={createTestId(testId, `${dayIndex}-${d.date.toString()}`)}
                $isActive={getDate(focusedDate) === d.date}
                disabled={d.disabled || !d.selectable}
                buttonTheme={'transparent'}
                type={'button'}
                onClick={() => onChangeDate(d.date)}
              >
                {d.date}
              </CalendarButton>
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  )
}
